import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { elmiraConfig } from "./data";

export default function ElmiraPage() {
  return <CityPageTemplate config={elmiraConfig} />;
}